import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import reducers from "./reducers";

const appReducer = combineReducers({ ...reducers });

export const store = createStore(appReducer, applyMiddleware(thunk));
export default store;
